import { z } from 'zod';

import { learningPathOrderingSchema, studentLearningPathStatusSchema } from '@/features/learning-path';

export const essaysSearchParamsSchema = z.object({
  escola: z.coerce.number().int().optional(),
  anoLetivo: z.coerce.number().int().optional(),
  busca: z.string().optional(),
  // Superset of both profiles; CONCLUIDA is only offered to students.
  status: studentLearningPathStatusSchema.optional(),
  ordenacao: learningPathOrderingSchema.optional(),
  page: z.coerce.number().int().positive().optional(),
});

export type EssaysSearchParams = z.infer<typeof essaysSearchParamsSchema>;
